import React, { useState, useEffect } from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/landing/Hero';
import Features from './components/landing/Features';
import HowItWorks from './components/landing/HowItWorks';
import ExtensionPromo from './components/landing/ExtensionPromo';
import FAQ from './components/landing/FAQ';
import AnalysisDashboard from './components/dashboard/AnalysisDashboard';
import LoadingState from './components/common/LoadingState';

function App() {
  const [appState, setAppState] = useState('landing');
  const [productData, setProductData] = useState(null);
  const [error, setError] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  useEffect(() => {
    if (appState === 'dashboard') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [appState]);

  const handleAnalyze = async (productUrl) => {
    setError(null);

    // Basic Amazon URL Validation
    const isValid = productUrl && 
                  productUrl.toLowerCase().includes('amazon.') && 
                  productUrl.toLowerCase().includes('/dp/');

    if (!isValid) {
      setError("Please enter a valid Amazon product URL (e.g., containing 'amazon.com/dp/...')");
      return;
    }

    setIsAnalyzing(true);
    setAppState('loading');

    try {
      // Direct call to Activepieces Webhook as requested
      const response = await fetch("https://cloud.activepieces.com/api/v1/webhooks/WNtDdE2Or0K53oNRH1ErE/sync", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          url: productUrl
        })
      });

      if (!response.ok) {
        throw new Error("Webhook request failed");
      }

      const data = await response.json();
      console.log("Cheapo API response:", data);

      // The webhook might return data directly or inside a 'result' property
      const finalData = data.result || data;
      
      setProductData(finalData);
      setAppState('dashboard');

    } catch (err) {
      console.error("Analyze error:", err);
      setError("Unable to analyze this product. Please try again.");
      setAppState('landing');
    } finally {
      setIsAnalyzing(false);
    }
  };

  const resetApp = () => {
    setAppState('landing');
    setProductData(null);
    setError(null);
  };

  return (
    <div className="min-h-screen flex flex-col font-sans overflow-x-hidden bg-slate-50">
      <Header onLogoClick={resetApp} isDashboard={appState === 'dashboard'} />
      
      <main className="flex-grow pt-[90px] md:pt-[100px]">
        {appState === 'landing' && (
          <>
            <Hero onAnalyze={handleAnalyze} isAnalyzing={isAnalyzing} error={error} />
            <ExtensionPromo />
            <Features />
            <HowItWorks />
            <FAQ />
          </>
        )}

        {appState === 'loading' && (
          <LoadingState />
        )}

        {appState === 'dashboard' && productData && (
          <AnalysisDashboard 
            onNewSearch={resetApp} 
            data={productData}
          />
        )}
      </main>

      {appState === 'landing' && <Footer />}
    </div>
  );
}

export default App;